import React, {useEffect, useState, useMemo} from 'react';
import EmptyState from "components/emptyState";
import ApiDatabase from "server"
import UseContext from "hooks/useContext";
import Table from "components/table/table";
import {useOutletContext} from "react-router-dom";
import Pagination from "components/pagination/pagination";

const ToBeCheckedContent = () => {
    const {companyData,refreshTime} = UseContext()
    const [arrayTimeSheets, setArrayTimeSheets] = useState([])
    const [isWaiting, setIsWaiting] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const countPerPage = 25;
    const { searchValue = '', searchType = 'all' } = useOutletContext() || {};

    useEffect(() => {
        setIsWaiting(true)
        if(Object.keys(companyData).length) {
            ApiDatabase.getTimeSheets({id: companyData._id, p: '1'},
                (data) => {
                    setArrayTimeSheets(Array.isArray(data) ? data : [])
                    setIsWaiting(false)
                },
                (err) => {
                    console.log(err)
                    setArrayTimeSheets([])
                    setIsWaiting(false)
                })
        }
    }, [companyData, refreshTime])

    // Fonction de filtrage selon le type de recherche
    const filterItems = (items) => {
        if (!searchValue) return items;
        
        const searchLower = searchValue.toLowerCase();
        
        return items.filter(item => {
            switch (searchType) {
                case 'releve':
                    return item.id_time_sheet?.toString().toLowerCase().includes(searchLower);
                case 'interimaire':
                    const fullName = `${item.user[0]?.firstname || ''} ${item.user[0]?.lastname || ''}`.toLowerCase();
                    return fullName.includes(searchLower);
                case 'mission':
                    const missionTitle = item.mission[0]?.title?.toLowerCase() || '';
                    const missionId = item.mission[0]?.id_mission?.toString().toLowerCase() || '';
                    return missionTitle.includes(searchLower) || missionId.includes(searchLower);
                case 'all':
                default:
                    const allSearch = `${item.id_time_sheet || ''} ${item.user[0]?.firstname || ''} ${item.user[0]?.lastname || ''} ${item.mission[0]?.title || ''} ${item.mission[0]?.id_mission || ''}`.toLowerCase();
                    return allSearch.includes(searchLower);
            }
        });
    };

    const filteredTimeSheets = useMemo(() => {
        if (!Array.isArray(arrayTimeSheets)) return [];
        return filterItems(arrayTimeSheets);
    }, [arrayTimeSheets, searchValue, searchType]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchValue, searchType, arrayTimeSheets]);

    const countTotal = Array.isArray(filteredTimeSheets) ? filteredTimeSheets.length : 0;
    const totalPages = Math.max(1, Math.ceil(countTotal / countPerPage));
    const paginatedTimeSheets = Array.isArray(filteredTimeSheets) ? filteredTimeSheets.slice(
        (currentPage - 1) * countPerPage,
        currentPage * countPerPage
    ) : [];

    const titles=['N° de relevé','MISSION', 'Intérimaire','période']

    return (
        <div>
            {
                isWaiting ? (
                    <Table champsBody={[]} champsHeader={titles} isWaiting={true}/>
                ) : (
                    <>
                        {
                            arrayTimeSheets?.length > 0 ? (
                                filteredTimeSheets?.length > 0 ? (
                                    <>
                                        <Table champsBody={paginatedTimeSheets} champsHeader={titles}/>
                                    </>
                                ) : (
                                    <EmptyState type={'time_sheet'}/>
                                )
                            ) : (
                                    <EmptyState type={'time_sheet'}/>
                            )
                        }
                    </>
                )
            }
            {!isWaiting && filteredTimeSheets?.length > 0 && countTotal > countPerPage && (
                <div className="fixed bottom-0 left-0 right-0 border-t border-gray-100 bg-white px-8 py-4 z-50 tab:left-[80px] sidebar-expanded:left-64">
                    <Pagination
                        currentPage={currentPage}
                        countPerPage={countPerPage}
                        countTotal={countTotal}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            )}
        </div>
    );
};

export default ToBeCheckedContent;